module.exports = __webpack_public_path__ + "static/img/pop.2227cea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pop.gif
// module id = +Ony
// module chunks = 1